'use strict';
define([
    'angular',
    'modules/seochecker/results/social/social.controller'
], function (angular, SEOCheckerSocialController) {
    var app = angular.module('app.seochecker.results.social', []);
    app.controller('SEOCheckerSocialController', SEOCheckerSocialController);
    return app;
});
